import React from 'react';
import clsx from 'clsx';
import styles from './personalized-header.module.scss';

type PersonalizedHeaderProps = {
  productsCount: number;
  isLoading?: boolean;
  title: string;
  subTitle: string;
  pageType?: string;
  hasOnlySubheader?: boolean;
} & React.HTMLProps<HTMLDivElement>;

const PersonalizedHeader: React.FC<PersonalizedHeaderProps> = (props) => {
  const {
    productsCount = 0,
    isLoading,
    children,
    title,
    subTitle,
    pageType = 'personalized',
    hasOnlySubheader = false,
  } = props;
  return (
    <div className={clsx(styles.personalizedHeader, hasOnlySubheader && styles['personalizedHeader--onlySubheader'])}>
      <div
        className={clsx(
          styles.personalizedHeader__container,
          hasOnlySubheader && styles['personalizedHeader__container--onlySubheader'],
        )}
      >
        <div>
          {!hasOnlySubheader && (
            <h1
              className={clsx(styles.personalizedHeader__title, 'vc-title-s')}
              data-cy={`${pageType}__header__title`}
            >
              {title}
            </h1>
          )}
          <div
            className={clsx(
              styles.personalizedHeader__counter,
              !isLoading && productsCount > 0 && styles['personalizedHeader__counter--visible'],
            )}
            data-cy={`${pageType}__header__counter`}
            aria-atomic="true"
            aria-live="polite"
          >
            <span
              className={styles.personalizedHeader__counter__number}
              data-cy={`${pageType}__header__counter__number`}
            >
              {productsCount}{' '}
            </span>
            <span
              className={styles.personalizedHeader__counter__text}
              data-cy={`${pageType}__header__counter__text`}
            >
              {subTitle}
            </span>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

export default PersonalizedHeader;
